import { defineStore } from 'pinia'

export default defineStore({
  id: 'nodeDataTable',
  persist: true,
  state: () => {
    return {
      columnState: [],
      isNodeArchive: false,
      isNodeConnectionArchive: false,
      isNodeLocationArchive: false,
      isNodeTypeArchive: false
    }
  },
  actions: {
    setColumnNodeState: function (payload: any) {
      this.columnState = payload
    },
    setIsNodeArchive: function (payload: boolean) {
      this.isNodeArchive = payload
    },
    setIsNodeConnectionArchive: function (payload: boolean) {
      this.isNodeConnectionArchive = payload
    },
    setIsNodeLocationArchive: function (payload: boolean) {
      this.isNodeLocationArchive = payload
    },
    setIsNodeTypeArchive: function (payload: boolean) {
      this.isNodeTypeArchive = payload
    }
  },
  getters: {
    getColumnNodeState: (state: any) => state.columnState,
    getIsNodeArchive: (state: any) => state.isNodeArchive,
    getIsNodeConnectionArchive: (state: any) => state.isNodeConnectionArchive,
    getIsNodeLocationArchive: (state: any) => state.isNodeLocationArchive,
    getIsNodeTypeArchive: (state: any) => state.isNodeTypeArchive
  }
})
